<template>
  <div class="provincias container">
    <custom-select
      label="Provincia"
      :value="value"
      :name="name"
      @input="onChange"
      :items="provincias"
      :quantumObfuscate="quantumObfuscate"
    />
  </div>
</template>

<script>
import { provincias } from "@/config/constants/index";
import CustomSelect from "@/components/core/custom/CustomSelect";
export default {
  name: "ProvinceList",
  components: { CustomSelect },
  props: {
    value: String,
    name: String,
    quantumObfuscate: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    provincias() {
      return provincias;
    }
  },
  methods: {
    onChange(val) {
      this.$emit("input", val);
    }
  }
};
</script>
